import { RouteObject } from "react-router-dom";
import { AuthGuard } from "../app/auth";

export const orderRoutes: RouteObject[] = [
  {
    async lazy() {
      const { Page } = await import("./page");
      return {
        element: (
          <AuthGuard>
            <Page />
          </AuthGuard>
        ),
      };
    },
    children: [
      {
        index: true,
        path: "",
        lazy: async () => {
          const { Orders } = await import("./orders");
          return { Component: Orders };
        },
      },
      {
        path: ":id",
        lazy: async () => {
          const { ReturnFlow } = await import("./returnFlow/return-flow");
          return { Component: ReturnFlow };
        },
      },
      {
        path: ":id/exchange",
        lazy: async () => {
          const { AdvancedExchange } = await import(
            "./returnFlow/cardContents/advanced-exchange"
          );
          return { Component: AdvancedExchange };
        },
      },
      {
        path: "return/:id",
        lazy: async () => {
          const { ReturnStatus } = await import("./return-status");
          return { Component: ReturnStatus };
        },
      },
    ],
  },
];
